export default __webpack_public_path__ + "static/tn-gold-rush-banner-6553c4cbe5ac472c3d1da9bcd6ec3451.jpg";